interface ItemSlot {
	name: string;
}

interface ItemSlots {
	[key: number]: ItemSlot;
}

export const itemSlots: ItemSlots = {
	1: {
		name: "Head"
	},
	2: {
		name: "Neck"
	},
	3: {
		name: "Shoulder"
	},
	5: {
		name: "Chest"
	},
	6: {
		name: "Waist"
	},
	7: {
		name: "Legs"
	},
	8: {
		name: "Feet"
	},
	9: {
		name: "Wrist"
	},
	10: {
		name: "Hands"
	},
	11: {
		name: "Finger"
	},
	12: {
		name: "Trinket"
	},
	13: {
		name: "One-Hand"
	},
	14: {
		name: "Off-Hand"
	},
	15: {
		name: "Ranged"
	},
	16: {
		name: "Back"
	},
	17: {
		name: "Two-Hand"
	},
	23: {
		name: "Held In Off-Hand"
	}
};

export default itemSlots;

